const Styles = ({ palette, spacing }) => {
  const tableContentStyle = {
    fontSize: 14.5,
    lineHeight: '28px',
    fontWeight: 400,
  };
  return ({
    headingStyle: {
      display: 'block',
      fontWeight: 500,
      textAlign: 'left',
    },
    headingTooltip: {
      flex: '1 1 0',
      minWidth: 0,
    },
    dialogContentStyle: {
      backgroundColor: palette.background.paper,
    },
    subHeadTextStyle: {
      fontSize: 14.5,
      textTransform: 'capitalize',
      fontWeight: 400,
      lineHeight: '17px',
      color: palette.text.primary,
    },
    tableContentStyle,
    ellipseStyle: {
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      maxWidth: 25,
    },
    qScrollStyle: {
      padding: '23px 15px', 
      paddingBottom: 0,
      borderTopLeftRadius: 5,
      borderTopRightRadius: 5,
      width: 500,
      height: 254,
      maxHeight: 300,
      overflow: 'auto',
      '& th': {
        ...tableContentStyle,
        color: palette.text.secondary,
        textAlign: 'left',
        '&:first-of-type': {
          width: '60%',
        },
        width: 150,
        '&:last-child': {
          textAlign: 'right',
        },
      },
      '& td': {
        ...tableContentStyle,
        '&:last-child': {
          textAlign: 'right',
        },
      },
    },
    chartWrapper: {
      height: 280,
      padding: '23px 15px 0',
    },
    specialRow: {
      borderTop: `1px solid ${palette.border.light}`,
    },
    tabStyle: {
      fontWeight: 400,
      color: palette.text.primary,
      textTransform: 'capitalize',
    },
    currentTabStyle: {
      borderTop: `2px solid ${palette.primary.light}`,
      color: `${palette.secondary.main} !important`,
      fontWeight: 500,
    },
    avarageWrapper: {
      marginBottom: 10,
    },
    totalTable: {
      width: '100%',
      background: palette.background.paper,
      textAlign: 'right',
      borderBottomLeftRadius: 5,
      borderBottomRightRadius: 5,
      '& td': {
        fontSize: 14,
        '&:first-of-type': { width: '60%' },
        '&:nth-of-type(2)': { textAlign: 'left' },
        '&:last-child': { paddingRight: 15 },
      },
    },
    dialogTitle: {
      paddingLeft: 24,
      paddingRight: spacing(1.5),
      justifyContent: 'left',
      '& > #dlg-close': {
        position: 'static',
        flexShrink: 0,
        marginLeft: spacing(2),
      },
    },
    barChartWrapper: {
      height: '100%',
    },
  });
};

export default Styles;
